import { ChevronUp } from 'lucide-react';

import type { FC } from 'react';

const DrawerHandle: FC<{ onClick: () => void }> = ({ onClick }) => (
  <div
    onClick={onClick}
    role="button"
    tabIndex={0}
    aria-label="Open panel"
    className="flex items-center justify-center cursor-pointer relative left-1/2 bg-white bottom-3 size-7.5 rounded-full border border-border"
  >
    <ChevronUp className="size-4" aria-hidden="true" />
  </div>
);

export default DrawerHandle;
